import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DazzedParagraph16 from 'components/common/text/DazzedParagraph16'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import OggHeading32 from 'components/common/text/OggHeading32'
import { isMobile } from 'utils/mobileUtils'
import TrademarkText from 'components/common/TrademarkText'

const useStyles = makeStyles({
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    padding: '0 15px',
    paddingTop: isMobile() ? 30 : 60
  },
  title: {
    marginBottom: 15,
    fontWeight: 600
  },
  subText: {
    fontFamily: 'Dazzed',
    fontWeight: 500,
    lineHeight: '18px',
    color: 'var(--text-color-6)',
    textAlign: 'center',
    marginBottom: 20
  },
  subTitleText: {
    fontFamily: 'Dazzed',
    fontWeight: 500,
    lineHeight: '18px',
    color: 'var(--text-color-6)',
    textAlign: 'center',
    marginBottom: 20,
    minHeight: 44
  },
  imageSection: {
    minHeight: 190,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  widthSection: {
    minHeight: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  widthText: {
    fontSize: 13
  },
  grinScopeImage: {
    marginBottom: 20,
    width: 150
  },
  grinScopeArrowImage: {
    alignSelf: 'center',
    marginBottom: 10,
    height: 10
  }
})

const OrderGrinKitInfo = ({
  title,
  subTitle,
  subTitleFontSize,
  scopeImage,
  arrowImage,
  width,
  description,
  descriptionFontSize
}) => {
  const classes = useStyles()

  return (
    <div className={classes.body}>
      {isMobile() ? (
        <OggHeading32>
          <TrademarkText text={title} />
        </OggHeading32>
      ) : (
        <DazzedParagraph16 className={classes.title} textAlign="center">
          <TrademarkText text={title} />
        </DazzedParagraph16>
      )}
      <div
        className={classes.subTitleText}
        style={subTitleFontSize ? { fontSize: subTitleFontSize } : { fontSize: 14 }}
      >
        {subTitle}
      </div>
      <div className={classes.imageSection}>
        {scopeImage ? <img className={classes.grinScopeImage} src={scopeImage} alt="Grin scope" /> : null}
        <div className={classes.widthSection}>
          {arrowImage ? <img className={classes.grinScopeArrowImage} src={arrowImage} alt="arrow" /> : null}
          {width ? (
            <DazzedParagraph12 className={classes.widthText} textAlign="center">
              {width}
            </DazzedParagraph12>
          ) : null}
        </div>
      </div>
      <div
        className={classes.subText}
        style={descriptionFontSize ? { fontSize: descriptionFontSize } : { fontSize: 14 }}
      >
        {description}
      </div>
    </div>
  )
}

export default OrderGrinKitInfo
